/*=========================================================================================
Các state dùng cho project
==========================================================================================*/

const getters = {
  userStatus: (state) => state.userStatus,
  roleUser: (state) => state.roleUser,
  roleSelect: (state) => state.roleSelect,
  disabledRole: (state) => state.disabledRole,
  merchants: (state) => state.merchants ?? [],
  RoleLocal: (state) => {
    return state.RoleLocal
      ? state.RoleLocal
      : localStorage.getItem("RoleLocal")
        ? JSON.parse(localStorage.getItem("RoleLocal"))
        : {};
  },

  //Các biến phục vụ cho thu hộ doanh nghiệp
  cboCustomers: (state) => state.cboCustomers,
  currentPeriod: (state) => state.currentPeriod,
};

export default getters;
